"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.settingsFactory = exports.SettingsFactory = void 0;
const launch_darkly_browser_settings_provider_1 = __importDefault(require("./providers/launch-darkly-browser-settings-provider"));
const settings_manager_1 = require("./settings-manager");
const settings_providers_type_1 = require("./types/settings-providers.type");
class SettingsFactory {
    async create(providersTypes, launchDarklyBrowserConfig = null) {
        const providersList = providersTypes.map((p) => this.getProvider(p));
        this.validateProviders(providersList);
        const providersInitialized = await this.initializeProviders(providersList, launchDarklyBrowserConfig);
        const settingsManager = new settings_manager_1.SettingsManager();
        return await settingsManager.init(providersInitialized);
    }
    async initializeProviders(providers, launchDarklyBrowserConfig) {
        const promises = providers.map((provider) => {
            return provider.init(launchDarklyBrowserConfig);
        });
        return Promise.all(promises);
    }
    validateProviders(providers) {
        if (!providers || providers.length === 0) {
            throw new Error('SettingsProvider must be initialized before using get');
        }
    }
    getProvider(providerType) {
        switch (providerType) {
            case settings_providers_type_1.SettingsProvidersType.LAUNCHDARKLY:
                return launch_darkly_browser_settings_provider_1.default;
        }
    }
}
exports.SettingsFactory = SettingsFactory;
exports.settingsFactory = new SettingsFactory();
